import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import HomeScreen from "./HomeScreen";
import GamesScreen from "./GamesScreen";
import PlayGameScreen from "./PlayGameScreen";
import { UserProvider } from "./UserContext"; // Asegúrate de importar esto
import Footer from "./Components/Footer"; // Importa el componente Footer
import PrivacyPolicy from "./Components/PrivacyPolicy"; // Importa el componente PrivacyPolicy
import Terms from "./Components/Terms"; // Importa el componente Terms
import TournamentScreen from "./features/Tournaments/TournamentScreen";

function App() {
  return (
    <UserProvider>
      <Router>
        <Routes>
          <Route path="/" element={<HomeScreen />} />
          <Route path="/juegos" element={<GamesScreen />} />
          <Route path="/play/:gameId" element={<PlayGameScreen />} />
          <Route path="/torneos/:tournamentId" element={<TournamentScreen />} />
          {/* Nuevas rutas para páginas legales */}
          <Route path="/politica-de-privacidad" element={<PrivacyPolicy />} />
          <Route path="/terminos-uso" element={<Terms />} /> {/* La ruta para Términos de Uso */}
          {/* Puedes agregar más pantallas aquí */}
        </Routes>
        <Footer /> {/* El pie de página global */}

      </Router>
    </UserProvider>
  );
}

export default App;
